import { Component, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { EmailComposer } from '@awesome-cordova-plugins/email-composer/ngx';
import { ModalController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { LibraryService } from 'src/app/core/services/library/library.service';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { ClinicDetailQuery } from 'src/app/shared/state/clinic-detail/clinic-detail.query';
import { ClinicDetailState } from 'src/app/shared/state/clinic-detail/clinic-detail.store';
import { Browser } from '@capacitor/browser';
import { Clipboard } from '@capacitor/clipboard';

@Component({
    selector: 'app-social-networks',
    templateUrl: './social-networks.component.html',
    styleUrls: ['./social-networks.component.scss'],
})
export class SocialNetworksComponent implements OnInit {
    clinic$: Observable<ClinicDetailState>;

    constructor(
        private modalController: ModalController,
        private clinicDetailQuery: ClinicDetailQuery,
        private toastService: ToastService,
        private libraryService: LibraryService,
        private emailComposer: EmailComposer
    ) {}

    ngOnInit(): void {
        this.clinic$ = this.clinicDetailQuery.select();
    }

    closeModal(): void {
        this.modalController.dismiss();
    }

    getUserNameFromUrl(url: string, prefix: string): string {
        const match = url.match(
            /https?:\/\/(www\.)?(?:twitter|medium|facebook|vimeo|instagram)\.com\/(#!\/)?@?([^\/]*)/
        );

        if(match && match.length >= 3){
            return prefix+url.match(
                /https?:\/\/(www\.)?(?:twitter|medium|facebook|vimeo|instagram)\.com\/(#!\/)?@?([^\/]*)/
            )[3];
        }else{
            return url;
        }
        
    }

    async openUrl(link) {
        if (Capacitor.isNativePlatform()) {
            await Browser.open({ url: link });
        } else {
            const win = window.open(link, '_blank');
            win.focus();
        }
    }

    /* send email */
    async sendEmail(mailto: string) {
        try {
            await Clipboard.write({
                string: mailto,
            });
            await this.toastService.presentInfoToast(
                this.libraryService.getLabel('app_mail_copy_success')
            );
        } catch (e) {
            await this.toastService.presentErrorToast(
                this.libraryService.getLabel('app_mail_copy_error')
            );
        }
        if (Capacitor.isNativePlatform()) {
            const email = {
                to: mailto,
            };
            this.emailComposer.open(email);
        } else {
            window.location.href = 'mailto:' + mailto;
        }
    }
}
